import React from "react";

export const PhotoIcon = () => {
	return (
		<svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M20 16C16.686 16 14 18.6872 14 22C14 25.314 16.686 28 20 28C23.3132 28 26 25.314 26 22C26 18.6872 23.3132 16 20 16ZM36 10H31.2C30.54 10 29.8288 9.488 29.6204 8.8616L28.3796 5.138C28.1704 4.512 27.46 4 26.8 4H13.2C12.54 4 11.8288 4.512 11.6204 5.1384L10.3796 8.862C10.1704 9.488 9.46 10 8.8 10H4C1.8 10 0 11.8 0 14V32C0 34.2 1.8 36 4 36H36C38.2 36 40 34.2 40 32V14C40 11.8 38.2 10 36 10ZM20 32C14.4772 32 10 27.5228 10 22C10 16.4776 14.4772 12 20 12C25.522 12 30 16.4776 30 22C30 27.5228 25.522 32 20 32ZM34.6 16.7972C33.8272 16.7972 33.2 16.1708 33.2 15.3972C33.2 14.6244 33.8272 13.9972 34.6 13.9972C35.3736 13.9972 36 14.6244 36 15.3972C36 16.1708 35.3732 16.7972 34.6 16.7972Z"
				fill="white"
			/>
		</svg>
	);
};
